import React from 'react'
import { connect } from 'react-redux';
import styles from "./IndicatorsDashbordInfo.module.css";

import {getInfoSupp} from '../../../../actions/report'

import BtnBack from '../../helper/btnBack/BtnBack';
import GetHeader from '../../helper/getHeader/GetHeader';
import back1 from '../../../../assets/dashboard/background_1.png'
import circle from '../../../../assets/dashboard/circle.png'
import { useEffect } from 'react';
import { getNormalMass } from '../../../../utils/getArrFromObj'

const IndicatorsDashbordInfo = ({
  getInfoSupp,
  info_supp = []
}) => {

  useEffect(() => {
    getInfoSupp()
  }, [])

const colors = ['red', 'blue', 'green', 'blueviolet', 'yellow'];


const getSum = (data) => data?.reduce((accumulator, currentValue) => accumulator + currentValue.count, 0); //Получаем сумму баллов
const getPers = (data, sum) => data?.map(el=> `${el.count / (sum / 100)}` ).sort( (a, b) => a - b); //Получаем отсортированный список баллов в процентах

  const getValues = (data) => {
    const sum = getSum(data)
    const toPersList = getPers(data, sum);

    let start = toPersList && [`${colors[0]} 0% ${toPersList[0]}%`]; //Стартовый массив
    let persSumm = +toPersList[0]; //Сумма процентов
    const x = toPersList?.map((el, inx) => {
      
      if (inx > 0 && toPersList.length - 1 != inx) {   
        persSumm = persSumm + +el  
        start.push(`${colors[inx]} ${toPersList[inx - 1]}% ${persSumm}%`)
      }

      if (toPersList.length - 1 == inx) {
        if (toPersList.length == 2) {
        } 
        start.push(`${colors[inx]} ${persSumm}%`)
      }
      
    })

    return start;
  }
  
  const getConicGradient = (data) => {
    const x = `conic-gradient(${getValues(data)?.map(el => `${el}`)})`; //Формируем сonic-пradient css-стиль 
    return x;
  }

  return (
    <div className={styles.wrapper}>
      <img src={back1} className={styles.bg}/>
      <GetHeader title={<>Показатели информаницонного обеспечения образовательной деятельности</>}/>

      <div className={styles.wrapperInner}>
        <div>
          <div 
          className={styles.speciality}>
            <div className={styles.speciality_title}>В вузах минобороны России разработано {info_supp.electronic_textbook?.count} электронных учебников и учебных пособий</div>
              
            <div className={styles.chartContainer}>
              <div 
                className={styles.pieChart}
                style={{
                  backgroundImage: getConicGradient([{count: info_supp.electronic_textbook?.base}, {count: info_supp.electronic_textbook?.others}]),
                  width: '300px',
                  height: '300px'
                }}
                ></div>

              <div className={styles.pieLegenda}>
              <div className={styles.entry}>
                  <div className={styles.entryColor} style={{background: `${colors[0]}`}}></div>
                  <div className={styles.entryText}>Базовые <span>{info_supp.electronic_textbook?.base}</span></div>
              </div>
              <div className={styles.entry}>
                  <div className={styles.entryColor} style={{background: `${colors[1]}`}}></div>
                  <div className={styles.entryText}>Остальные <span>{info_supp.electronic_textbook?.others}</span></div>
              </div>
            </div>
            </div>
            </div>
          <div className={styles.pc}>
            <div className={styles.pc_title}>Слушатели вузов минобороны России на 100% обеспечены персональными ЭВМ</div>
              {info_supp?.pc && 
              <div className={styles.blocks}>
                <div className={styles.dopTitle}>Обеспеченность курсантов <br/> персональными ЭВМ (%)</div>
                
                {getNormalMass(info_supp?.pc.year_stat_perc).sort((a, b) => a.value - b.value).map((el, inx) => 
                  <div style={{position: 'relative'}}>
                    <div className={styles.percTop}>{el.value}%</div>
                    <div className={styles[`honors_degreeBlock`]}>
                      <div className={styles.chartCylinder}
                      style={{minHeight: '60px', margin: '0 auto', height: `${230 / getNormalMass(info_supp?.pc.year_stat_perc)?.map(el => el.value).sort((a, b) => b - a)[0] * el.value}px`}}>
                      </div>
                      <span style={{width: '100px', height: '76px'}}>{el.key}</span>
                    </div>
                  </div>
                )}
              </div>
              }
          </div>
        </div>
        
        <div className={styles.countBlock}>
          <div>
          <div className={styles.countBlock_title}>Электронная библиотека</div>
          <div className={styles.countBlock_titleSmall}>Образовательных и научных организаций</div>
          <div className={styles.countBlock_titleSmall}>Минобороны России</div>

          <div className={styles.countUserBlock}>
            <span className={styles.countUserBlockTitle}>Количество пользователей</span>
            <div className={styles.countUserBlockCount}>{info_supp?.library?.users} <span className={styles.countUserBlockdop}>чел.</span></div>
          </div>
          </div>
        

        <div className={styles.infoResBlock}>
              {info_supp?.pc && 
              <div className={styles.blocks_library}>
                <div className={styles.dopInfo}>Загрузка информативныз <br/> русурсов   (открытый сегмент)</div>
                
                <div className={styles.library}>
                {getNormalMass(info_supp?.library?.ir_loading).map(el => el)
                .sort((a, b) => a.value - b.value).map((el, inx) => 
                  <div style={{position: 'relative'}}>
                    <div className={styles.percTop}>{el.value}%</div>
                    <div className={styles[`honors_degreeBlock`]}>
                      <div className={styles.chartCylinderRes}
                      style={{minHeight: '60px', height: `${230 / getNormalMass(info_supp?.library?.ir_loading)?.map(el => el.value).sort((a, b) => b - a)[0] * el.value}px`, margin: '0 auto'}}>
                      </div>
                      <span>{el.key}</span>
                    </div>
                  </div>
                )
                }
                </div>
              </div>
              }
        </div>
        </div>
      </div>
      <BtnBack/>

    </div>
  )
}

const mapStateToProps = (state) => ({
  info_supp: state.report.info_supp
});
  
  export default connect(mapStateToProps, {
    getInfoSupp 
  })(IndicatorsDashbordInfo);